import { apiV2 } from './http';

// eslint-disable-next-line import/prefer-default-export
export const getBillingMethods = () => apiV2.get(`/billing-methods`);
